module.exports = __webpack_public_path__ + "img/open-card.b38534a8.gif";